<template>
	<el-container class="min-width">
		<el-header>{{ unitName }}</el-header>
		<div class="sign-up" :style="{ 'justify-content': list.length === 1 ? 'center' : 'flex-start', transform: list.length === 1 ? 'translateY(-100px)' : 'translateY(0)' }">
			<div class="list" v-for="(item, index) in list" :key="index">
				<div class="shadow">
					<i class="el-icon-document"></i>
					<span>{{ item.examination_name }}</span>
					<p v-if="!isTest" :class="item.state === 1 ? 'yes' : 'no'">{{ item.status }}</p>
				</div>
				<div class="date-time">
					<span class="label">{{ item.status_name }} :</span>
					<span class="date">
					<span v-if="!isTest && item.other_advice === 0">{{ item.time1 }} 至 {{ item.time2 }}</span>
					<span v-else-if="!isTest && item.other_advice === 1">另行通知</span>
					<span v-else>测试使用</span>
					</span>
					<span class="btn" v-if="(item.state === 1 || isTest)" @click="handleSign(item)">
					<span v-if="item.other_state === 0">报名入口</span>
					<span v-else-if="item.other_state === 1">打印入口</span>
					<span v-else-if="item.other_state === 2">成绩查询入口</span>
					</span>
					<span v-else></span>
					<span v-if="item.down_name" style="width:360px; float:right; text-align:right; font-size:24px;">
						<span style="display: block;">{{item.down_name}}</span>
						<span style="display: block;">
						<span style="color: red;">{{item.dd}}</span>天  
						<span style="color: red;">{{item.hh}}</span>时  
						<span style="color: red;">{{item.mm}}</span>分  
						<span style="color: red;">{{item.ss}}</span>秒 
						</span>
					</span>
				</div>
				<div v-if="tip === 1" style="font-size:24px; ">
					<p style="color: red; ">特别提醒：</p>
					<p v-for="(item, index) in link" :key="index">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						<a target="_blank" :href="item.url">
							{{item.msg}}
						<!-- </a><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						<a target="_blank" :href="item.url">
							资格复审地点：内蒙古新视野考试中心
						</a><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						<a target="_blank" :href="item.url">
							详情及所需材料请查看公告
						</a><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						<a target="_blank" :href="item.url">
							面试时间：2025年4月2日14:00
						</a><br> -->
					</p>
					<p v-for="(item, index) in img" :key="index">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{item.ps}}
						<el-image style="width: 600px; height: 50px;background-color: #f5f7fa;line-height: 100px;"
								:src="item.img" :preview-src-list="[item.img]">
								<div slot="error" style="text-align: center;"><i style="font-size: 30px;"
										class="el-icon-picture-outline"></i></div>
							</el-image>
					</p>
				</div>
			</div>
		</div>
		<div class="copyright"><a style="text-decoration: none; color:black" target="_blank" href="https://beian.miit.gov.cn/ ">渝ICP备2024041183号-1</a></div>
	</el-container>

</template>

<script>
import { reqLoginName, reqGetExaminationList, reqToLogin } from '@/api';
import { MessageBox } from 'element-ui';
import { mapState } from 'vuex';
export default {
	data() {
		return {
			list: [],
			tip: 0,
			link: [],
			img: [],
			sign: 0,
		};
	},
	computed: {
		...mapState({
			refresh: state => state.system.refresh,
			unitName: state => state.system.unitName,
		}),
		isTest() {
			return this.$route.params.test;
		}
	},
	mounted() {
		this.init();
		if(this.refresh) {
			this.$store.commit('system/SET_REFRESH', 0);
			window.location.href = `${window.location.origin}${window.location.pathname}?${Date.now()}`;
			return;
		}
		this.getName();
	},
	methods: {
		// 初始化
		init() {
			this.$store.commit('system/SET_EXAM_INFO', {});
			this.$store.commit('system/SET_COMPANY_ID', '');
			this.$store.commit('system/SET_PAY_MENT', {});
			this.$store.commit('user/SET_EXAMINEE', {});
			this.$store.commit('user/SET_USER_INFO', {});
			this.$store.commit('user/SET_ADD_FORM_NUM', 1);
			this.$store.commit('user/SET_REFRESH_NUM', 1);
			this.$store.commit('user/SET_API_COUNT', 1);
			this.$store.commit('user/SET_TOTAL', []);
			localStorage.removeItem('promise');
		},
		// 获取单位名称
		getName() {
			reqLoginName({check: this.refresh}).then(res => {
				if (res.data[2]) {
					window.open(res.data[2], '_self');
				}
				this.$store.commit('system/SET_REFRESH', 1);
				this.getExaminationList();
				this.$store.commit('system/SET_UNIT_ID', res.data[0].unit_id);
				this.$store.commit('system/SET_UNIT_NAME', res.data[0].name);
				this.$store.commit('system/SET_UNIT_CODE', res.data[0].unit);
				this.$store.commit('system/SET_MOBILE', res.data[1]);
			}).catch((error => {
				console.log(error);
			}));
		},
		// 直通登录
		getLogin(id) {
			if (this.sign === 0) {
				reqToLogin({
					id: id
				}).then(res => {
					if (res.msg == 'wait') {
						this.sign = 1;
						let _this = this;
						let timerId = setTimeout(function() {
							_this.sign = 0;
						}, 10000);
						MessageBox.alert('当前登陆人数较多，请10分钟后尝试刷新登录！！！', '温馨提示', {
							confirmButtonText: '确定',
							callback: action => {
								this.$message({
									type: 'info',
									message: `请稍后！！！`
								});
							}
						});
						return;
					} else {
						if (res.data) {
							this.$router.push('/search');
						} else {
							this.$router.push('/agreement');
						}
					}
				}).catch((error => {
					console.log(error);
				}));
			} else {
				MessageBox.alert('当前登陆人数较多，请10分钟后尝试刷新登录！！！', '温馨提示', {
					confirmButtonText: '确定',
					callback: action => {
						this.$message({
							type: 'info',
							message: `请稍后！！！`
						});
					}
				});
				return;
			}
		},
		// 获取报名考试列表
		getExaminationList() {
			reqGetExaminationList().then(res => {
				this.list = res.data.list;
				this.link = res.data.link;
				this.img = res.data.img;
				if (this.link.length !== 0 || this.img.length !== 0) {
					this.tip = 1;
				}
				var myNewData = [];
				this.list.map(((item, index) => {
					myNewData.push(item)
					this.$set(item, "ss", this.getTimeList())
				}));
				if(res.data.msg) {
					MessageBox.alert(res.data.msg, '温馨提示', {
						confirmButtonText: '确定',
					});
				}
				this.list = myNewData;
			}).catch((error => {
				console.log(error);
			}));
		},
		// 报名入口
		handleSign(data) {
			this.$store.commit('system/SET_EXAM_INFO', data);
			console.log('examInfo:' + data);
			console.log('company_id:' + data.company_id);
			this.$store.commit('system/SET_COMPANY_ID', data.company_id);
			this.getLogin(data.examination_id);
		},
	    getTimeList() {
			var _this = this;
			setInterval(function() {
			for (var key in _this.list) {
				var start = new Date().getTime();
				var end = Date.parse(_this.list[key]["time2"])
				var rightTime = end - start;
				if (rightTime > 0) {
				var dd = Math.floor(rightTime / 1000 / 60 / 60 / 24);
				var hh = Math.floor((rightTime / 1000 / 60 / 60) % 24);
				var mm = Math.floor((rightTime / 1000 / 60) % 60);
				var ss = Math.floor((rightTime / 1000) % 60);
				dd = dd > 9 ? dd : '0' + dd
				hh = hh > 9 ? hh : '0' + hh
				mm = mm > 9 ? mm : '0' + mm
				ss = ss > 9 ? ss : '0' + ss
				_this.list[key]["dd"] = dd;
				_this.list[key]["hh"] = hh;
				_this.list[key]["mm"] = mm;
				_this.list[key]["ss"] = ss;
				} else {
				_this.list[key]["dd"] = '00';
				_this.list[key]["hh"] = '00';
				_this.list[key]["mm"] = '00';
				_this.list[key]["ss"] = '00';
				}
			}
			}, 1000);
	    },
	}
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/color.scss';

.min-width {
	min-width: 1200px;
}

.el-header {
	background-color: $--color-primary;
	box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.04);
	font-size: 28px;
	color: #ffffff;
	line-height: 60px;
	padding-left: 80px;
}
.copyright {
	position: fixed;
	bottom: 5px;
	left: 50%;
	transform: translateX(-50%);
	font-size: 14px;
}

.sign-up {
	height: calc(100vh - 160px);
	overflow-x: hidden;
	overflow-y: auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 50px 0;

	.list {
		width: 1100px;
		background: #ffffff;
		box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.06);
		padding-top: 28px;
		font-size: 22px;

		.shadow {
			min-height: 60px;
			background: #f9f9f9;
			box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.16);
			display: flex;
			align-items: center;
			padding: 10px 0 10px 32px;

			> i {
				font-size: 20px;
				margin-right: 20px;
			}

			> span {
				line-height: 1.5;
				width: 60%;
			}

			> p {
				margin-left: auto;
				font-size: 14px;
				padding: 0 20px 0 40px;
				height: 35px;
				line-height: 35px;
				text-align: center;

				&.yes {
					color: #fff;
					background: url(../assets/imgs/1.png) no-repeat;
					background-size: 100% 100%;
				}

				&.no {
					background: url(../assets/imgs/2.png) no-repeat;
					background-size: 100% 100%;
				}
			}
		}

		.date-time {
			display: flex;
			align-items: center;
			font-size: 18px;
			color: #000000;
			height: 80px;
			padding: 0 32px;

			.date {
				margin-left: 15px;
			}

			.btn {
				width: 150px;
				height: 35px;
				background: #ffffff;
				border: 2px solid #2461ed;
				line-height: 35px;
				text-align: center;
				cursor: pointer;
				font-size: 16px;
				color: #2461ed;
				border-radius: 10px;
				margin-left: auto;
			}
		}
	}

	.list + .list {
		margin-top: 20px;
	}
}
</style>
